import { FileText } from '@liveauctioneers/hammer-ui-core/icons';
import { BodySecondary, H3 } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

type FileAttachment = {
    name: string;
    preview: string;
    type: string;
};

type Props = {
    readonly attachedFiles: FileAttachment[];
    readonly handleDeleteDraft: Function;
    readonly loading: boolean;
    readonly setAttachedFiles: Function;
    readonly testid?: string;
};

const filePreviewContainerBase =
    'relative flex h-[75px] w-[75px] items-center justify-center overflow-hidden rounded-[10px] bg-surface-100 border border-text-secondary';

export const AttachedFileList = ({
    attachedFiles,
    handleDeleteDraft,
    loading,
    setAttachedFiles,
    testid = 'messengerAttachedFileList',
}: Props) => {
    const removeAttachment = (filename: string, fileIndex: number) => {
        if (loading) {
            return;
        }
        handleDeleteDraft(filename);
        return !loading && setAttachedFiles(attachedFiles.filter((_, index) => index !== fileIndex));
    };

    return (
        <div
            className="m-[20px] flex flex-row flex-wrap items-start"
            data-testid={testid}
        >
            {attachedFiles.map(({ name, preview, type }, i) => (
                <div
                    className="group/file-item mb-xs mr-[27px] mt-xs flex max-w-[75px] flex-col items-center justify-center"
                    key={i}
                    onClick={() => removeAttachment(name, i)}
                    role="button"
                >
                    <div className={cn(filePreviewContainerBase, 'group-hover/file-item:border-primary-400')}>
                        {type.includes('image') && (
                            <img
                                className="max-h-[75px] max-w-[75px]"
                                src={preview}
                            />
                        )}
                        {!type.includes('image') && <FileText size="md" />}
                        <div className="bg-white/80 absolute inset-0 hidden select-none items-center justify-center group-hover/file-item:flex">
                            <BodySecondary>{loading ? 'Loading' : 'Remove'}</BodySecondary>
                        </div>
                    </div>
                    <BodySecondary className="break-all group-hover/file-item:text-primary-400">{name}</BodySecondary>
                </div>
            ))}
            {attachedFiles.length < 5 && (
                <div className="group/file-item mb-xs mr-[27px] mt-xs flex max-w-[75px] flex-col items-center justify-center">
                    <div
                        className={cn(
                            filePreviewContainerBase,
                            'border-dashed border-text-inactive group-hover/file-item:border-text-inactive'
                        )}
                    >
                        <H3>+{5 - attachedFiles.length}</H3>
                    </div>
                </div>
            )}
        </div>
    );
};
